import { Partner } from '@constants/paymentLink';

const payment = {
  kushki: {
    merchantId: process.env.REACT_APP_KUSHKI_PUBLIC_KEY || '',
    inTestEnvironment: process.env.REACT_APP_KUSHKI_IS_TEST_ENV?.toLowerCase() === 'true',
    regional: process.env.REACT_APP_KUSHKI_IS_REGIONAL?.toLowerCase() === 'true',
  },

  paymentMethods: {
    card: {
      locales: ['mx', 'us', 'ca'],
    },
    cash: {
      locales: ['mx'],
    },
    spei: {
      locales: ['mx'],
    },
    directDebit: {
      locales: ['mx'],
    },
  },
  partner: process.env.REACT_APP_PAYMENT_PARTNER || 'dlocal',
};

export const CARD_PARTNER = (process.env.REACT_APP_PAYMENT_PARTNER as Partner) || Partner.DLOCAL;
export const CASH_PARTNER = Partner.KUSHKI;
export const SPEI_PARTNER = Partner.STP;
export const DIRECT_DEBIT_PARTNER = Partner.BELVO;

export default payment;
